
class SingleLinkedNode {
    constructor(value) {
        this.val = value;
        this.next = null;
    }
}

export default SingleLinkedNode;